export const DEVICE_MOBILE = 'mobile';
export const DEVICE_DESKTOP = 'desktop';
